import React from "react";
import calculatorJson from "../../../Configs/JSON/calculator.json"
import "../../../styles/Calculator/CalculateOptions.less"
import Options from "./Options"

const CalculateOptions = ( props ) => {
  return (
    <>
        <div className="optionsParentCont">
            <div className="ttl">{calculatorJson["calculatorScr2Question"]}</div>
            <Options onClickFunction={ props.onClickFunction } />
        </div>
    </>
  )
}

export default CalculateOptions
